/** @format */

import DesignListUngrouped from './designs_ungrouped_table/design_list_ungrouped';
import {ArchivedOrdersContextProvider} from './archived_orders_context_provider';
import {GroupedByOrderList} from './orders_grouped_table/grouped_by_order_list';
import useGroupedbyOrder from '../shared/use_grouped_by_order';
import {SelectSearchBy} from '../shared/select_search_by';
import {IfElse} from 'frontier-utilities';
import React from 'react';

export default function Container() {
    const {showGroupedByOrders, handleToggleGroupByOrders} = useGroupedbyOrder();
    return (
        <ArchivedOrdersContextProvider>
            <div className="d-flex align-items-center justify-content-end mb-4">
                <SelectSearchBy
                    handleToggleGroupByOrders={handleToggleGroupByOrders}
                    showGroupedByOrders={showGroupedByOrders}
                />
            </div>
            <IfElse condition={showGroupedByOrders}>
                <GroupedByOrderList />
                <DesignListUngrouped />
            </IfElse>
        </ArchivedOrdersContextProvider>
    );
}
